@use "stylesheets/utility/variables";

.unauthLayoutWrapper {
  display: flex;
  justify-content: center;
  padding-top: variables.$primary-header-height + 48px;
  @media (max-width: variables.$laptop) {
    padding-top: variables.$primary-header-height-mobile + 32px;
  }
}

.unauthLayoutContent {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2xl);
  width: 400px;
  margin-bottom: var(--spacing-5xl);
  @media (max-width: variables.$laptop) {
    margin: 0 var(--spacing-2xl) var(--spacing-2xl);
  }
}

.large {
  width: 533px;
}
